import Vue from 'vue'
import {Mutation, Action, VuexModule, getModule, Module} from "vuex-module-decorators";
import store from "../store";
import {CmsApiClient} from "@/_global/api_clients/CmsApiClient";
import {Util} from "@/_global/utils";

@Module({
    name: "ThemesStore",
    dynamic: true,
    store: store,
    namespaced: true
})
class ThemesStore extends VuexModule {
    // state
    private _apiResponse: CMS.Theme[] = [];
    private _themeById: { [themeId: number]: CMS.Theme } = {};

    private _selectedTheme: CMS.Theme = {} as any;
    private _selectedThemePageByName: { [pageName: string]: CMS.Page } = {} as any;

    // getter
    get all() {
        return this._apiResponse || [];
    }

    get themeById() {
        return this._themeById || {};
    }

    get selectedTheme(): CMS.Theme {
        return this._selectedTheme || {};
    }

    get selectedThemePageByName(): { [pageName: string]: CMS.Page } {
        return this._selectedThemePageByName || {};
    }

    get defaultThemeId(): number {
        // todo メニュー作成したときのデフォルトテーマを選ぶ仕組みを作ってもよい
        return this._apiResponse.map(v => v.id)[0] || -1;
    }

    @Action
    public async init() {
        this.initVals();

        const response: CMS.Theme[] = await CmsApiClient.getThemes();
        this.setResponse(response);
        for (let i = 0; i < response.length; i++) {
            this.setThemeById(response[i]);
        }
        this.selectTheme(this.defaultThemeId);
    }

    @Mutation
    private initVals(): void {
        this._apiResponse = [];
        this._themeById = {};
        this._selectedTheme = {} as any;
        this._selectedThemePageByName = {};
    }

    @Mutation
    private setResponse(response: CMS.Theme[]) {
        this._apiResponse = response;
    }

    @Mutation
    private setThemeById(theme: CMS.Theme) {
        Vue.set(this._themeById, theme.id, theme);
    }

    @Mutation
    public selectTheme(themeId: number) {
        this._selectedTheme = this._themeById[themeId];

        this._selectedThemePageByName = {};
        for (let i = 0; i < this._selectedTheme.theme_options.pages.length; i++) {
            const page = this._selectedTheme.theme_options.pages[i];
            Vue.set(this._selectedThemePageByName, page.name, page);
        }
    }
}

export default getModule(ThemesStore);
